import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * Keeps the PDP pre-order notice in sync on a live variant switch.
 * Not a morph target from product-form.js, so it refreshes itself independently,
 * mirroring the pattern used by product-inventory.js.
 */
class BbdPreOrderNote extends Component {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#abortController.signal
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        const { html, productId, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (productId && this.dataset.productId && productId !== this.dataset.productId) {
          return;
        }

        const newNote = html.querySelector(`bbd-pre-order-note[data-block-id="${this.dataset.blockId}"]`);
        if (!newNote) return;

        this.hidden = newNote.hasAttribute('hidden');
        morph(this, newNote, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[bbd-pre-order-note] Product select promise rejected:', error);
      });
  };
}

if (!customElements.get('bbd-pre-order-note')) {
  customElements.define('bbd-pre-order-note', BbdPreOrderNote);
}
